import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import { pastFinancialdate } from "../../lib/Misc";
import { useMediaQuery } from "../../components/use-media-query";
import ReconcileTransactions from "./ReconcileTransactions";
import ReconciledItems from "./ReconciledItems";
import BankTransactions from "./BankTransactions";
import AuditTrial from "./AuditTrail/AuditTrial";
import MonthlyBankReconciliation from "../Reports/MonthlyBankReconciliation";
import { useTrust } from "../../lib/context/TrustContext";
import { useUser } from "../../lib/context/UserContext";

const Banking = ({ org = false }) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const tabsKey = org
    ? [
        {
          name: "Monthly Bank Reconciliation",
          tabName: "monthly-bank-reconciliation",
          value: 6,
        },
      ]
    : [
        {
          name: "Reconcile Transactions",
          tabName: "reconcile-transactions",
          value: 1,
        },
        {
          name: "Reconciled Items",
          tabName: "reconcile-item",
          value: 2,
        },
        {
          name: "Under Review",
          tabName: "under-review",
          value: 3,
        },
        {
          name: "Bank Transactions",
          tabName: "bank-transactions",
          value: 4,
        },
        {
          name: "Audit Trail",
          tabName: "audit-trail",
          value: 5,
        },
        {
          name: "Monthly Bank Reconciliation",
          tabName: "monthly-bank-reconciliation",
          value: 6,
        },
      ];

  const selectedTab = query.get("tab")
    ? query.get("tab")
    : org
    ? "monthly-bank-reconciliation"
    : "reconcile-transactions";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  const fromDate = query.get("from")
    ? new Date(query.get("from")?.split("-").reverse().join("-"))
    : "";
  const toDate = query.get("to")
    ? new Date(query.get("to")?.split("-").reverse().join("-"))
    : "";
  const { trustId: trustID } = useTrust(org);
  const [trustId, setTrustId] = useState(org ? "" : trustID);
  const [selectedDateRange, setSelectedDateRange] = useState(
    fromDate && toDate
      ? {
          from: fromDate,
          to: toDate,
        }
      : {
          from: pastFinancialdate[0],
          to: pastFinancialdate[1],
        }
  );

  useEffect(() => {
    setTrustId(trustID);
  }, [trustID]);

  // useEffect(() => {
  //   navigate(
  //     `/banking?tab=${
  //       tabsKey?.find((item) => item?.value === activeTab)?.tabName
  //     }`,
  //     {
  //       replace: true,
  //     }
  //   );
  // }, [activeTab, navigate]);

  const { permission } = useUser();

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        actionAlign={"end"}
        actionContent={""}
        mainClassName="w-[calc(100%-3rem)]"
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={
            activeTab === 6
              ? "p-2 max-h-[82vh] overflow-y-auto"
              : "max-h-[80vh] overflow-y-auto"
          }
        >
          {activeTab === 1 ? (
            <ReconcileTransactions
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
              readAccess={permission?.["bank-reconciliations"]?.read}
              writeAccess={permission?.["bank-reconciliations"]?.write}
            />
          ) : activeTab === 2 ? (
            <ReconciledItems
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
              readAccess={permission?.["bank-reconciliations"]?.read}
              writeAccess={permission?.["bank-reconciliations"]?.write}
            />
          ) : activeTab === 3 ? (
            <ReconcileTransactions
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
              underReview={true}
              readAccess={permission?.["bank-reconciliations"]?.read}
              writeAccess={permission?.["bank-reconciliations"]?.write}
            />
          ) : activeTab === 4 ? (
            <BankTransactions
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
              readAccess={permission?.["bank-transactions"]?.read}
              writeAccess={permission?.["bank-transactions"]?.write}
            />
          ) : activeTab === 5 ? (
            <AuditTrial
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
              readAccess={permission?.["bank-transactions"]?.read}
              writeAccess={permission?.["bank-transactions"]?.write}
            />
          ) : (
            <MonthlyBankReconciliation
              trustId={trustId}
              setTrustId={setTrustId}
              isDesktop={isDesktop}
              org={org}
            />
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default Banking;
